import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_pquyv3p5bf: FaireCollectionEntity = {
  token: "pbc_pquyv3p5bf",
  type: "collection",
  name: "Birthday 🎈🎁",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b230428b0b90d212024e40f62d5012bbdbbd79d4f8373cc71df5f6bdd6db50c9.jpeg",
  itemCount: 51,
  description:
    "Cue the confetti.....The perfect celebration outfit for any Birthday Boy or Girl! ",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:38.997Z",
    importedBy: "entity-db-import-collections",
  },
};
